import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";

import $ from "jquery";

import { Group as LayerGroup, Tile as TileLayer, Image as ImageLayer } from "ol/layer";
import { TileWMS, WMTS, ImageWMS } from "ol/source";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { getTopLeft } from "ol/extent";
import { transform, Projection } from "ol/proj";

import { FiPlusSquare, FiMinusSquare } from "react-icons/fi";
import { MdCheckBoxOutlineBlank, MdCheckBox, MdIndeterminateCheckBox } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp, IoIosSettings } from "react-icons/io";
import { GrLayer } from "react-icons/gr";

export default class SisTree {
	constructor(props = {}) {
		if (!props.map) {
			return false;
		}

		this.map = props.map;
		this.isSubTree = props.isSubTree ? props.isSubTree : false;
		this.url = props.url; // json 데이터를 가져올 url
		this.id = props.id; // tree element id
		this.legend = props.legend ? props.legend : false; // 범례 사진
		this.rootType = props.rootType ? props.rootType : "tree"; //최상위루트 스타일

		this.disableSetting = props.disableSetting;
		this.optionModal = null;

		this.lstRootGroup = []; // 최상위 그룹 리스트
		this.lstGroup = []; // 하위그룹 리스트
		this.lstAllGroup = []; // 모든 그룹 리스트
		this.lstLayers = []; // 모든 레이어 리스트

		this.treeList = []; // 화면분할 서브트리 리스트

		this.layers = {};

		this.init();
		window.sisTree = this;
	}

	init = () => {
		$.ajax({
			url: this.url,
			async: false,
			success: (res) => {
				this.treeElement = this.createElements(res);
			},
		});

		return this.treeElement;
	};

	// 다시 불러오기
	reload = () => {
		// 초기화
		this.lstRootGroup = []; // 최상위 그룹 리스트
		this.lstGroup = []; // 하위그룹 리스트
		this.lstAllGroup = []; // 모든 그룹 리스트
		this.lstLayers = []; // 모든 레이어 리스트

		$.each(this.layers, (idx, lyr) => {
			lyr.setVisible(false);
		});

		$.ajax({
			url: this.url,
			async: false,
			success: (res) => {
				this.jsonData = res;
				this.treeElement = this.createElements(res);
			},
		});
	};

	createElements = (data) => {
		const treeWrapElement = document.getElementById(this.id); // 트리 Wrap
		$(treeWrapElement).addClass("sisLayerTree");

		ReactDOM.unmountComponentAtNode(treeWrapElement);

		data.forEach((item) => {
			const nodeType = item.type; // 레이어인지 그룹인지
			const nodeParentId = item.parent; // 부모엘리먼트 id
			const nodeLoad = item.load; // 로딩 여부
			const nodeBase = item.base; // 배경지도, 항공영상인지 여부
			const authority = item.authority; // 권한

			if (nodeLoad && authority === "public") {
				if (nodeType === "group") {
					if (nodeParentId === "sisTreeRoot") {
						this.createRootGroup(item);
					} else {
						if (!nodeBase) this.createGroup(item);
							//this.createGroup(item);
					}
				} else if (nodeType === "layer") {
					if (!nodeBase) {
						this.createLayer(item);
					} else {
						this.createAirphoto(item);
					}
				}
			}
		});

		// 루트 그룹에 하위그룹들 추가
		this.lstGroup.forEach((grp) => {
			this.lstRootGroup.forEach((g) => {
				if (g.props.node.id === grp.props.node.parent) {
					g.props.childrenElement.push(grp);
					return;
				}
			});
		});

		// 그룹에 하위그룹들 추가
		this.lstAllGroup.forEach((grp) => {
			// console.log(grp);

			if (grp.props.node.parent !== "sisTreeRoot") {
				this.lstAllGroup.forEach((g, idx) => {
					if (g.props.node.id === grp.props.node.parent && g.props.node.parent !== "sisTreeRoot") {
						g.props.childrenElement.push(grp);

						return;
					}
				});

				if (!grp.props.isSub) this.lstGroup.push(grp);
			}
		});

		// 그룹에 레이어들 추가
		this.lstAllGroup.forEach((grp) => {
			this.lstLayers.forEach((lyr) => {
				if (grp.props.node.id === lyr.props.node.parent) {
					grp.props.childrenElement.push(lyr);
					return;
				}
			});
		});

		// 그룹 체크박스 맞춤
		this.lstAllGroup.forEach((grp) => {
			// console.log(grp.props.childrenElement);
		});

		ReactDOM.render(
			<div id="sisTreeRoot" className="sisRootGroup">
				<div id="rootChildren">
					{this.lstRootGroup.map((grp) => {
						return grp;
					})}
				</div>
			</div>,
			treeWrapElement
		);
	};

	// 최상위 그룹 생성
	createRootGroup = (item) => {
		const rootGrp = <RootGroup key={item.id} node={item} childrenElement={[]} />;
		this.lstRootGroup.push(rootGrp);
		this.lstAllGroup.push(rootGrp);
	};

	// 하위그룹 생성
	createGroup = (item) => {
		const target = this.isSubTree ? this.map.getTarget() + "_subMap" : this.map.getTarget();

		const grp = <Group key={item.id} node={item} target={target} childrenElement={[]} checkboxHandler={this.checkboxHandler} childrenHandler={this.childrenHandler} parentHandler={this.parentHandler} />;
		this.lstAllGroup.push(grp);
		this.lstGroup.push(grp);

		// this.lstRootGroup.forEach((g) => {
		// 	if (g.props.node.id === item.parent) {
		// 		g.props.childrenElement.push(grp);
		// 		return;
		// 	}
		// });
	};

	// 레이어 생성
	createLayer = (item) => {
		const target = this.isSubTree ? this.map.getTarget() + "_subMap" : this.map.getTarget();

		if (!this.layers[item.id]) {
			this.layers[item.id] = new ImageLayer({
				title: item.id,
				id: item.id,
				name: item.layerName,
				korName: item.korName,
				visible: false,
				zIndex: item.zindex,
				minZoom: item.minZoom - 1,
				maxZoom: item.maxZoom + 1,
			});

			/*this.layers[item.id] = new TileLayer({
				title: item.id,
				id: item.id,
				name: item.layerName,
				korName: item.korName,
				visible: false,
				zIndex: item.zindex,
				minZoom: item.minZoom - 1,
				maxZoom: item.maxZoom + 1,
			  });*/

			this.layers[item.id].setSource(
				new ImageWMS({
					projection: this.map.getView().getProjection().getCode(),
					//url: `/sde/wms`,
					url:`/map/proxy/wms.do`,
					params: {
						LAYERS: item.layerName,
						VERSION: "1.1.0",
						FORMAT: "image/png",
						TRANSPARENT: true,
						TILED : true,
					},
					serverType: "geoserver",
				})
			);

			/*this.layers[item.id].setSource(
				new TileWMS({
				  url: '/map/proxy/wms.do',
				  params: {
					LAYERS: item.layerName,
					VERSION: '1.1.0',
					FORMAT: 'image/png',
					TRANSPARENT: true,
					TILED: true,
				  },
				  serverType: 'geoserver',
				})
			);*/

			this.map.addLayer(this.layers[item.id]);
		}

		const lyr = (
			<Layer key={item.id} node={item} target={target} layer={this.layers[item.id]} settingHandler={this.settingHandler} checkboxHandler={this.checkboxHandler} childrenHandler={this.childrenHandler} parentHandler={this.parentHandler} />
		);

		this.lstLayers.push(lyr);
	};

	// 원본(20220608)
	createAirphoto2 = (item) => {
		let projection;
		let resolutions;
		let extent;
		var matrixIds, matrixSet;

		projection = "EPSG:5186";

		if (item.layerName.indexOf("2008_2009") > -1 || item.layerName.indexOf("2019") > -1 || item.layerName.indexOf("2021") > -1) {
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5181_${item.layerName}`;
		} else {
			matrixIds = [
				`EPSG:5186_${item.layerName}:0`,
				`EPSG:5186_${item.layerName}:1`,
				`EPSG:5186_${item.layerName}:2`,
				`EPSG:5186_${item.layerName}:3`,
				`EPSG:5186_${item.layerName}:4`,
				`EPSG:5186_${item.layerName}:5`,
				`EPSG:5186_${item.layerName}:6`,
				`EPSG:5186_${item.layerName}:7`,
				`EPSG:5186_${item.layerName}:8`,
				`EPSG:5186_${item.layerName}:9`,
				`EPSG:5186_${item.layerName}:10`,
				`EPSG:5186_${item.layerName}:11`,
				`EPSG:5186_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5186_${item.layerName}`;
		}

		resolutions = [
			529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
			0.1322919312505292,
		];

		extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];

		this.layers[item.layerName] = new TileLayer({
			kind: item.type,
			title: item.layerName,
			id: item.layerName,
			zIndex: item.zindex,
			source: new WMTS({
				url: `/gwc/service/wmts`,
				layer: item.layerName,
				matrixSet: matrixSet,
				format: "image/jpeg",
				projection,
				tileGrid: new WMTSTileGrid({
					origin: getTopLeft(extent),
					resolutions: resolutions,
					matrixIds: matrixIds,
				}),
				imageSmoothing: false,
			}),
			visible: item.visibility,
		});

		this.map.addLayer(this.layers[item.layerName]);
	};

	// 수정본(20220608)
	createAirphoto = (item) => {
		let projection;
		let resolutions;
		let extent;
		let origin;
		var matrixIds, matrixSet;

		projection = "EPSG:5186";
		extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];
		origin = getTopLeft(extent);
		resolutions = [
			529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
			0.1322919312505292,
		];

		if (item.layerName.indexOf("2021") > -1 || item.layerName.indexOf("2022") > -1) {
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
				`EPSG:5181_${item.layerName}:13`,
			];

			matrixSet = `EPSG:5181_${item.layerName}`;

			projection = new Projection({
				code: "EPSG:5181",
				extent: [-30000, -60000, 494288, 988576],
				units: "m",
			});

			extent = [-5423200.0,3144.0,343968.0,6294600.0];
			resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
			origin = [-5423200.0, 6294600.0];
		} else if(item.layerName.indexOf("2023") > -1){
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
				`EPSG:5181_${item.layerName}:13`,
			];
			matrixSet = `EPSG:5181_${item.layerName}`;

			projection = new Projection({
				code: "EPSG:5181",
				extent: [-30000, -60000, 494288, 988576],
				units: "m",
			});

			extent = [-5423200.0,3144.0,343968.0,6294600.0];
			resolutions = [1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25, 0.125];
			origin = [-5423200.0, 6294600.0];
		} else if (item.layerName.indexOf("2008_2009") > -1 || item.layerName.indexOf("2019") > -1) {
			matrixIds = [
				`EPSG:5181_${item.layerName}:0`,
				`EPSG:5181_${item.layerName}:1`,
				`EPSG:5181_${item.layerName}:2`,
				`EPSG:5181_${item.layerName}:3`,
				`EPSG:5181_${item.layerName}:4`,
				`EPSG:5181_${item.layerName}:5`,
				`EPSG:5181_${item.layerName}:6`,
				`EPSG:5181_${item.layerName}:7`,
				`EPSG:5181_${item.layerName}:8`,
				`EPSG:5181_${item.layerName}:9`,
				`EPSG:5181_${item.layerName}:10`,
				`EPSG:5181_${item.layerName}:11`,
				`EPSG:5181_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5181_${item.layerName}`;
		} else {
			matrixIds = [
				`EPSG:5186_${item.layerName}:0`,
				`EPSG:5186_${item.layerName}:1`,
				`EPSG:5186_${item.layerName}:2`,
				`EPSG:5186_${item.layerName}:3`,
				`EPSG:5186_${item.layerName}:4`,
				`EPSG:5186_${item.layerName}:5`,
				`EPSG:5186_${item.layerName}:6`,
				`EPSG:5186_${item.layerName}:7`,
				`EPSG:5186_${item.layerName}:8`,
				`EPSG:5186_${item.layerName}:9`,
				`EPSG:5186_${item.layerName}:10`,
				`EPSG:5186_${item.layerName}:11`,
				`EPSG:5186_${item.layerName}:12`,
			];
			matrixSet = `EPSG:5186_${item.layerName}`;

			extent = [-5423200, 150556.31191262323, 285105.81661163364, 6394600];
			resolutions = [
				529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 33.0729828126323, 16.933367200067735, 8.466683600033868, 4.233341800016934, 2.116670900008467, 1.0583354500042335, 0.5291677250021167, 0.2645838625010584,
				0.1322919312505292,
			];
		}

		this.layers[item.layerName] = new TileLayer({
			kind: item.type,
			title: item.layerName,
			id: item.layerName,
			zIndex: item.zindex,
			source: new WMTS({
				url: `/gwc/service/wmts`,
				// url: "/map/proxy/proxyBackgroundByUrl.do",
				// url: "http://sisnet.iptime.org:9002/gwc/service/wmts",
				layer: item.layerName,
				matrixSet: matrixSet,
				format: "image/png",
				projection,
				tileGrid: new WMTSTileGrid({
					origin,
					tileSize: [256, 256],
					extent,
					resolutions,
					matrixIds: matrixIds,
				}),
				imageSmoothing: false,
				wrapX: true,
			}),
			visible: item.visibility,
		});

		this.map.addLayer(this.layers[item.layerName]);
	};

	// 체크박스 change 이벤트
	checkboxHandler = (evt) => {
		let isGrp = false;

		let target = evt.target.closest(".layer"); //레이어인가??
		if (!target) {
			isGrp = true;
			target = evt.target.closest(".group"); //그룹인가?
		}
		const id = target.id;

		const checkboxSpan = $("#" + this.id + " #" + id + ".sisTreeCheckboxSpan"); // 체크박스 Span 이미지 찾기
		$(checkboxSpan).toggleClass("on"); // on class toggle
		$(checkboxSpan).toggleClass("off"); // on class toggle

		// 상위 or 하위 체크박스 컨트롤
		if (isGrp) {
			// 그룹일때
			this.childrenHandler(target);
		} else {
			// 레이어일때
			this.parentHandler(target);

			if (!evt.target.checked) {
				this.layers[id].setVisible(false);
			} else {
				this.layers[id].setVisible(true);
			}
		}
	};

	// 하위 체크박스 변경
	childrenHandler = (item) => {
		const checked = item.querySelector("input[name=" + item.id + "]").checked;
		const layerCheckboxs = item.querySelectorAll(".children .layer input");

		layerCheckboxs.forEach((checkbox) => {
			if (checkbox.checked !== checked) checkbox.click();
		});
	};

	// 부모 체크박스 변경
	parentHandler = (item) => {
		const parentId = item.getAttribute("parent");
		const parentWrap = item.closest("#" + parentId);
		const parentCheckbox = parentWrap.querySelector(`input[name=${parentId}]`);
		const parentCheckboxSpan = parentWrap.querySelector(".sisTreeCheckboxSpan");

		// 부모 그룹의 모든 레이어
		const layerCheckboxs = parentWrap.querySelectorAll(".layer input");

		// 부모 그룹의 체크상태 레이어
		const checkedLayer = parentWrap.querySelectorAll(".layer input:checked");

		// 체크박스 클래스 초기화
		parentCheckboxSpan.classList.remove("half");
		parentCheckboxSpan.classList.remove("on");
		parentCheckboxSpan.classList.remove("off");

		// 부모그룹 하위항목중 체크박스가 하나라도 체크된 경우
		if (checkedLayer.length > 0) {
			parentCheckbox.checked = true;

			// 모든 레이어가 체크되어있을때
			if (layerCheckboxs.length === checkedLayer.length) {
				parentCheckboxSpan.classList.add("on");
			} else {
				parentCheckboxSpan.classList.add("half");
			}
		} else {
			parentCheckboxSpan.classList.add("off");
			parentCheckbox.checked = false;
		}

		// 부모항목도 부모항목이 있을때
		const pParentId = parentWrap.getAttribute("parent");
		// console.log(pParentId);

		if (pParentId !== "sisTreeRoot") {
			this.parentHandler(parentWrap);
		}
	};

	// 레이어 설정 모달
	settingHandler = (lyr) => {
		if (this.optionModal) {
			this.optionModal.setLayer(lyr);
		}
	};
}

class RootGroup extends Component {
	checkbox = createRef();
	expand = createRef();
	children = createRef();

	// expand
	expandHandler = (evt) => {
		evt.preventDefault();
		const parent = evt.target.closest(".sisTreeRoot");
		const dropDownWrap = parent.querySelector(".dropdown");
		const dropDown = parent.querySelector(".sisTreeDropdown");
		const children = parent.querySelector(".children");

		dropDownWrap.classList.toggle("on");
		dropDownWrap.classList.toggle("off");

		dropDown.classList.toggle("on");
		dropDown.classList.toggle("off");

		$(children).slideToggle("fast");
	};

	render() {
		const { id, parent, korName, expand } = this.props.node;

		return (
			<div id={id} className="group sisTreeRoot" parent={parent}>
				<div className={expand ? "sisContentsWrap dropdown on" : "sisContentsWrap dropdown off"} onClick={this.expandHandler}>
					<label className="sisCheckboxLabel" htmlFor={id + "_input"}>
						<input ref={this.checkbox} type="checkbox" id={id + "_input"} name={id} defaultChecked={false} className="sisTreeCheckbox" />
						<div id={id} className="sisTreeCheckboxSpan off" ref={this.checkboxWrap}>
							<MdCheckBoxOutlineBlank size="20px" className="unChecked" />
							<MdCheckBox size="20px" className="checked" />
							<MdIndeterminateCheckBox size="20px" className="half" />
						</div>
						<span className="sisGroupTitle">{korName}</span>
					</label>
					<div className={expand ? "sisTreeDropdown dropdown on" : "sisTreeDropdown dropdown off"} ref={this.expand}>
						<IoIosArrowDown className="on" />
						<IoIosArrowUp className="off" />
					</div>
				</div>
				<div ref={this.children} className="children">
					{this.props.childrenElement.map((children) => {
						return children;
					})}
				</div>
			</div>
		);
	}
}

class Group extends Component {
	checkbox = createRef();
	children = createRef();

	state = {
		childrenElement: [],
	};

	// expand
	expandHandler = (evt) => {
		evt.preventDefault();
		const parent = evt.target.closest(".sisTreeGroup");

		const expand = parent.querySelector(".sisTreeExpand");
		$(expand).toggleClass("on");

		const children = parent.querySelector(".children");
		$(children).slideToggle("fast");
	};

	render() {
		const { id, parent, korName } = this.props.node;
		if(id==="GRP0045"){
			return (
				<div id={id} className="group sisTreeGroup" parent={parent}>
					<div className="sisContentsWrap">
						<div className="sisTreeExpand off" onClick={this.expandHandler}>
							<FiPlusSquare id={id} className="expandOn" size="20px" />
							<FiMinusSquare id={id} className="expandOff" size="20px" />
						</div>
						<label className="sisCheckboxLabel" htmlFor={id + "_" + this.props.target}>
							<input
								type="checkbox"
								id={id + "_" + this.props.target}
								name={id}
								className="sisTreeCheckbox"
								// defaultChecked={visibility}
								defaultChecked={false}
								onChange={this.props.checkboxHandler}
							/>
	
							<div id={id} className="sisTreeCheckboxSpan off">
								<MdCheckBoxOutlineBlank size="20px" className="unChecked" />
								<MdCheckBox size="20px" className="checked" />
								<MdIndeterminateCheckBox size="20px" className="half" />
							</div>
							<span className="sisGroupTitle">{korName}</span>
						</label>
					</div>
					<div className="children" >
						{this.props.childrenElement.map((children) => {
							return children;
						})}
					</div>
				</div>
			);
		}else{
			return (
				<div id={id} className="group sisTreeGroup" parent={parent}>
					<div className="sisContentsWrap">
						<div className="sisTreeExpand off" onClick={this.expandHandler}>
							<FiPlusSquare id={id} className="expandOn" size="20px" />
							<FiMinusSquare id={id} className="expandOff" size="20px" />
						</div>
						<label className="sisCheckboxLabel" htmlFor={id + "_" + this.props.target}>
							<input
								type="checkbox"
								id={id + "_" + this.props.target}
								name={id}
								className="sisTreeCheckbox"
								// defaultChecked={visibility}
								defaultChecked={false}
								onChange={this.props.checkboxHandler}
							/>
	
							<div id={id} className="sisTreeCheckboxSpan off">
								<MdCheckBoxOutlineBlank size="20px" className="unChecked" />
								<MdCheckBox size="20px" className="checked" />
								<MdIndeterminateCheckBox size="20px" className="half" />
							</div>
							<span className="sisGroupTitle">{korName}</span>
						</label>
					</div>
					<div className="children" style={{ display: 'none' }}>
						{this.props.childrenElement.map((children) => {
							return children;
						})}
					</div>
				</div>
			);
		}
		
	}
}

class Layer extends Component {
	checkbox = React.createRef();
	checkboxWrap = createRef();

	componentDidMount() {
		if (this.props.node.visibility) {
			this.checkbox.current.click();
		}
	}

	componentDidUpdate() {
		if (this.props.node.visibility) {
			this.checkbox.current.click();
		}
	}

	render() {
		let { id, parent, korName } = this.props.node;

		const layer = this.props.layer;
		const source = layer.getSource();
		let legendUrl = source.getLegendUrl() + "&width=35&height=25&legend_options=forceLabels:off";
		if(id==="LYR0315"){
			legendUrl = source.getLegendUrl() + "&width=35&height=25&legend_options=forceLabels:on";
			//korName = "";
			return (
			
				<div id={id} className="sisContentsWrap layer" parent={parent}>
					<label className="sisCheckboxLabel" htmlFor={id + "_" + this.props.target}>
						<input ref={this.checkbox} type="checkbox" id={id + "_" + this.props.target} name={id} className="sisTreeCheckbox" defaultChecked={false} onChange={this.props.checkboxHandler} />
						<div id={id} className="sisTreeCheckboxSpan off" ref={this.checkboxWrap}>
							<MdCheckBoxOutlineBlank size="20px" className="unChecked" />
							<MdCheckBox size="20px" className="checked" />
							<MdIndeterminateCheckBox size="20px" className="half" />
						</div>
						{/*<span className="sisGroupTitle">{korName}</span>*/}
						<div className="sisTreeLegend">
							{/* <GrLayer size="20px" /> */}
							<img style={{ marginTop: "-2px" }} src={legendUrl} alt={korName} />
						</div>
	
						
					</label>
					<div
						className="sisTreeSetting"
						onClick={() => {
							this.props.settingHandler(this.props.layer);
						}}
					>
						<IoIosSettings size="20px" />
					</div>
				</div>
			);
		}else{
			legendUrl = source.getLegendUrl() + "&width=35&height=25&legend_options=forceLabels:off";
			return (
			
				<div id={id} className="sisContentsWrap layer" parent={parent}>
					<label className="sisCheckboxLabel" htmlFor={id + "_" + this.props.target}>
						<input ref={this.checkbox} type="checkbox" id={id + "_" + this.props.target} name={id} className="sisTreeCheckbox" defaultChecked={false} onChange={this.props.checkboxHandler} />
						<div id={id} className="sisTreeCheckboxSpan off" ref={this.checkboxWrap}>
							<MdCheckBoxOutlineBlank size="20px" className="unChecked" />
							<MdCheckBox size="20px" className="checked" />
							<MdIndeterminateCheckBox size="20px" className="half" />
						</div>
	
						<div className="sisTreeLegend">
							{/* <GrLayer size="20px" /> */}
							<img style={{ marginTop: "-2px" }} src={legendUrl} alt={korName} />
						</div>
	
						<span className="sisGroupTitle">{korName}</span>
					</label>
					<div
						className="sisTreeSetting"
						onClick={() => {
							this.props.settingHandler(this.props.layer);
						}}
					>
						<IoIosSettings size="20px" />
					</div>
				</div>
			);
		}	

		
	}
		
}
